import { useTranslation } from 'react-i18next'

export const useEnergySourcingContractsTableLabelsMap = () => {
    const { t } = useTranslation('translations')

    return {
        name: t('energy_sourcing_contracts_table.name'),
        type: t('energy_sourcing_contracts_table.type'),
        usnCount: t('energy_sourcing_contracts_table.usn_count'),
        startDate: t('energy_sourcing_contracts_table.start_date'),
        endDate: t('energy_sourcing_contracts_table.end_date'),
        lastUpdate: t('energy_sourcing_contracts_table.last_updated'),
        updatedBy: t('energy_sourcing_contracts_table.updated_by'),
    }
}

export type EnergySourcingContractsTableLabelsMap = {
    name: string
    type: string
    usnCount: string
    startDate: string
    endDate: string
    lastUpdate: string
    updatedBy: string
}
